import { render, staticRenderFns } from "./SeksiPenyakitDetail.vue?vue&type=template&id=56e8e7be&"
import script from "./SeksiPenyakitDetail.vue?vue&type=script&lang=ts&"
export * from "./SeksiPenyakitDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports